import { createStore } from 'vuex'
import axios from 'axios'

const API_BASE_URL = 'http://localhost:5000/api'

export default createStore({
  state: {
    companyInfo: null,
    techCapabilities: [],
    products: []
  },
  getters: {
    getCompanyInfo: state => state.companyInfo,
    getTechCapabilities: state => state.techCapabilities,
    getProducts: state => state.products
  },
  mutations: {
    SET_COMPANY_INFO(state, info) {
      state.companyInfo = info
    },
    SET_TECH_CAPABILITIES(state, capabilities) {
      state.techCapabilities = capabilities
    },
    SET_PRODUCTS(state, products) {
      state.products = products
    }
  },
  actions: {
    async fetchCompanyInfo({ commit }) {
      try {
        const response = await axios.get(`${API_BASE_URL}/company-info`)
        commit('SET_COMPANY_INFO', response.data)
        return response.data
      } catch (error) {
        console.error('获取公司信息失败:', error)
      }
    },
    async fetchTechCapabilities({ commit }) {
      try {
        const response = await axios.get(`${API_BASE_URL}/tech-capabilities`)
        commit('SET_TECH_CAPABILITIES', response.data)
        return response.data
      } catch (error) {
        console.error('获取技术能力失败:', error)
      }
    },
    async fetchProducts({ commit }) {
      try {
        const response = await axios.get(`${API_BASE_URL}/products`)
        commit('SET_PRODUCTS', response.data)
        return response.data
      } catch (error) {
        console.error('获取产品信息失败:', error)
      }
    }
  },
  modules: {}
}) 